import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex w-full"
}
const _hoisted_2 = { class: "w-1/2 h-screen border-r" }
const _hoisted_3 = {
  key: 0,
  class: "flex p-6 items-center justify-between border-b"
}
const _hoisted_4 = { class: "px-2 text-xs bg-[#23A2B4] rounded-full text-white py-[2px] font-semibold leading-4" }
const _hoisted_5 = { class: "notif-container" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex items-center justify-between mb-2" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = { class: "date" }
const _hoisted_11 = { class: "text-sm text-admin-gray-500" }
const _hoisted_12 = { class: "lineclamp-2 text-sm text-admin-gray-500" }
const _hoisted_13 = { class: "w-1/2" }
const _hoisted_14 = {
  key: 0,
  class: "p-6"
}
const _hoisted_15 = { class: "flex flex-col gap-2 mb-6" }
const _hoisted_16 = { class: "text-lg font-semibold" }
const _hoisted_17 = { class: "text-sm text-admin-gray-500" }
const _hoisted_18 = { class: "text-sm" }
const _hoisted_19 = {
  href: "#",
  class: "inline-flex items-center font-normal p-3 border border-transparent rounded-lg text-sm focus:outline-none focus:border-admin-gray-900 focus:ring focus:ring-admin-gray-300 disabled:opacity-25 transition bg-admin-gray-900 hover:bg-admin-gray-700 active:bg-admin-gray-900 text-white"
}

import AdminLayout from '@/layouts/AdminLayout.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';

import AdminNotification from "@/classes/AdminNotification";
import { onMounted, ref } from 'vue';


// Data

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const loader    = ref(false);
const showError = ref(false);
const errorMsg  = ref(null);

const items = ref(null);
const unreadCounts = ref(0);
const selectedNotification = ref(null)

// Methods
const indexAdminNotification = () => {
    loader.value = true;

    AdminNotification.indexAdminNotification()
        .then((response: any) => {
            loader.value = false;

            items.value = response.data.notifications;
            unreadCounts.value = items.value.filter(x => x.read_at == null).length;
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const markRead = (id) => {
    loader.value = true;

    selectedNotification.value = items.value.find(x => x.id == id)

    AdminNotification.readAdminNotification(id)
        .then((response: any) => {
            loader.value = false;

            items.value = response.data.notifications;
            unreadCounts.value = items.value.filter(x => x.read_at == null).length;
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}


const markReadAll = () => {
    loader.value = true;

    AdminNotification.readAllAdminNotification()
        .then((response: any) => {
            loader.value = false;

            items.value = response.data.notifications;
            unreadCounts.value = items.value.filter(x => x.read_at == null).length;
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

onMounted( () => {
    indexAdminNotification();
});


return (_ctx: any,_cache: any) => {
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!

  return (_openBlock(), _createBlock(AdminLayout, { title: "Notifications" }, {
    default: _withCtx(() => [
      (_ctx.$hasPermission('receive-system-notifications'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.$hasPermission('mark-notifications-as-read'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(unreadCounts.value) + " Unread", 1),
                    _createElementVNode("p", {
                      class: "text-sm cursor-pointer",
                      onClick: _withModifiers(markReadAll, ["prevent"])
                    }, "Mark all as Read")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "notif-item p-6 border-b cursor-pointer",
                    onClick: _withModifiers(($event: any) => (markRead(item.id)), ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(item.data.title), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(["px-2 text-xs bg-[#23A2B4] rounded-full text-white py-[2px] font-semibold leading-4", item.read_at ? 'hidden' : 'block'])
                        }, "New", 2)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("p", _hoisted_11, _toDisplayString(item.created_at), 1)
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(item.data.message), 1)
                  ], 8, _hoisted_6))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              (selectedNotification.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("p", _hoisted_16, _toDisplayString(selectedNotification.value.data.title), 1),
                      _createElementVNode("p", _hoisted_17, _toDisplayString(selectedNotification.value.created_at), 1),
                      _createElementVNode("p", _hoisted_18, _toDisplayString(selectedNotification.value.data.message), 1)
                    ]),
                    _createElementVNode("a", _hoisted_19, [
                      _cache[2] || (_cache[2] = _createTextVNode(" View Schedule ", -1)),
                      _createVNode(_component_ArrowRightIcon, { class: "text-white w-4 h-4 ml-2" })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[1] || (_cache[1] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})